module.exports = __webpack_public_path__ + "img/collaborate_9.2b957842.jpg";